var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'component-check-list-item': true, 'pass': _vm.passed},on:{"click":_vm.clickItem}},[_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.probeId))]),_c('div',{staticClass:"item-time"},[_vm._v(_vm._s(_vm.time))]),_c('Icon',{attrs:{"name":"arrow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }